import { type SpawnResult, adaptAnimatedNodeProvider, spawn } from "@mdotm/shadcn/legacy/react-extensions";
import { InvestmentPickerDialog, type InvestmentPickerDialogProps } from "./InvestmentPickerDialog";

type SpawnInvestmentPickerDialogProps = Omit<
	InvestmentPickerDialogProps,
	"show" | "onClose" | "onAnimationStateChange"
>;

export function spawnInvestmentPickerDialog(props: SpawnInvestmentPickerDialogProps): SpawnResult<void> {
	return spawn<void>(
		adaptAnimatedNodeProvider(({ show, resolve, onHidden }) => {
			const sharedProps = {
				show,
				onAnimationStateChange: (
					state: Parameters<NonNullable<InvestmentPickerDialogProps["onAnimationStateChange"]>>[0],
				) => state === "hidden" && onHidden(),
				onClose: () => resolve(),
				onSubmitAsync: async (entities: Parameters<InvestmentPickerDialogProps["onSubmitAsync"]>[0]) => {
					await props.onSubmitAsync(entities);
					resolve();
				},
			};
			const dialogProps = (
				props.pagination
					? { ...props, pagination: props.pagination, ...sharedProps }
					: { ...props, compositionProvider: props.compositionProvider!, ...sharedProps }
			) as InvestmentPickerDialogProps;
			return <InvestmentPickerDialog {...dialogProps} />;
		}),
	);
}
